//import errorHandler from './errorHandler'
import publicApi from '../../../api/public.js'
import publicV2Api from '../../../api/publicV2.js'
import _ from 'lodash'

export default {
    sendEngagementData : (payload, next) => {
        publicApi.post(`/api/v2/eventLogs?pageId=${payload.query.pageId}`, payload.body, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    sendEngagementDataV2 : (payload, next) => {
        publicV2Api.post(`/visitor-events`, payload.body, (err, data) => {
            if(err) return next(err, null);
            next(null, data);
        })
    }
} 
